import { render, staticRenderFns } from "./AdditionalIndicator.vue?vue&type=template&id=dd0f0c40&scoped=true&"
import script from "./AdditionalIndicator.vue?vue&type=script&lang=ts&"
export * from "./AdditionalIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalIndicator.vue?vue&type=style&index=0&id=dd0f0c40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f0c40",
  null
  
)

export default component.exports